//const API_BASE = 'http://localhost:5001/api';
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
const getToken = () => localStorage.getItem('token');

const request = async (url, options = {}) => {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${url}`, {
    ...options,
    headers
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Ошибка запроса');
  }
  return data;
};

// ========== Аутентификация ==========
export const login = (email, password) =>
  request('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password })
  });

export const register = (email, password, name) =>
  request('/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email, password, name })
  });

export const forgotPassword = (email) =>
  request('/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify({ email })
  });

export const verifyResetCode = (email, code) =>
  request('/auth/verify-reset-code', {
    method: 'POST',
    body: JSON.stringify({ email, code })
  });

export const resetPassword = (email, code, newPassword) =>
  request('/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify({ email, code, newPassword })
  });

export const getCurrentUser = () => request('/auth/me');

// ========== Настройки пользователя ==========
export const getSettings = () => request('/settings');
export const saveSettings = (settings) =>
  request('/settings', {
    method: 'POST',
    body: JSON.stringify(settings)
  });

// ========== Данные камер и дашборд ==========
export const getCamerasData = () => request('/cameras/data');

// ========== Переменные (поля из packets) ==========
export const getVariableNames = (imei) =>
  request(`/variables/names?imei=${imei}`);

// ========== Таблицы конверсии ==========
export const getConversionTable = (cameraId) =>
  request(`/conversion/${cameraId}`);
export const saveConversionTable = (cameraId, rows) =>
  request(`/conversion/${cameraId}`, {
    method: 'POST',
    body: JSON.stringify({ rows })
  });
export const deleteConversionTable = (cameraId) =>
  request(`/conversion/${cameraId}`, {
    method: 'DELETE'
  });

// ========== График температуры ==========
export const getTemperatureGraph = (cameraId, hours = 24) =>
  request(`/cameras/graph/${cameraId}?hours=${hours}`);

// ========== Темы оформления ==========
export const getActiveThemes = () => request('/themes/active');
export const getAllThemes = () => request('/themes/admin/all');
export const createTheme = (themeData) =>
  request('/themes/admin', {
    method: 'POST',
    body: JSON.stringify(themeData)
  });
export const updateTheme = (id, themeData) =>
  request(`/themes/admin/${id}`, {
    method: 'PUT',
    body: JSON.stringify(themeData)
  });
export const deleteTheme = (id) =>
  request(`/themes/admin/${id}`, { method: 'DELETE' });

// ========== Администрирование (пользователи, биллинг) ==========
export const getUsers = () => request('/admin/users');
export const getUserById = (userId) => request(`/admin/users/${userId}`);
export const updateUser = (userId, data) =>
  request(`/admin/users/${userId}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
export const fullUpdateUser = (userId, data) =>
  request(`/admin/users/${userId}/full-update`, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
export const changeUserPassword = (userId, newPassword) =>
  request(`/admin/users/${userId}/change-password`, {
    method: 'POST',
    body: JSON.stringify({ newPassword })
  });
export const blockUser = (userId) =>
  request(`/admin/users/${userId}/block`, { method: 'POST' });
export const unblockUser = (userId) =>
  request(`/admin/users/${userId}/unblock`, { method: 'POST' });

// Биллинг
export const getUserBilling = (userId) =>
  request(`/admin/billing/${userId}`);
export const addPayment = (userId, payment) =>
  request(`/admin/billing/${userId}/payments`, {
    method: 'POST',
    body: JSON.stringify(payment)
  });
export const deletePayment = (userId, paymentId) =>
  request(`/admin/billing/${userId}/payments/${paymentId}`, {
    method: 'DELETE'
  });
export const getAdminStats = () => request('/admin/stats');

// ========== Telegram ==========
export const getTelegramSubscriptions = () =>
  request('/admin/telegram/subscriptions');
export const deleteTelegramSubscription = (id) =>
  request(`/admin/telegram/subscriptions/${id}`, { method: 'DELETE' });
export const updateUserTelegramLimit = (userId, limit) =>
  request(`/admin/users/${userId}/telegram-limit`, {
    method: 'PUT',
    body: JSON.stringify({ limit })
  });